module.exports = __webpack_public_path__ + "img/article_7_2.8bcd00d6.png";